import { render } from "./ShowProduct.vue?vue&type=template&id=306843e3&scoped=true"
import script from "./ShowProduct.vue?vue&type=script&lang=js"
export * from "./ShowProduct.vue?vue&type=script&lang=js"

import "./ShowProduct.vue?vue&type=style&index=0&id=306843e3&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306843e3"]])

export default __exports__